import { render } from "./GenericModal.vue?vue&type=template&id=3f1a3910&ts=true"
import script from "./GenericModal.vue?vue&type=script&lang=ts"
export * from "./GenericModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__